import React from 'react'
import './Header.css'
import matka from '../../images/matka.png'
import coin from '../../images/coin.png'
import whatsapp from '../../images/whatsapp.png'
import telegram from '../../images/telegram.png'
import mobilemockup from '../../images/mobile-mockup.png'
import slide1 from '../../images/mobile-slide1.png'
import slide2 from '../../images/mobile-slide2.png'
import slide3 from '../../images/mobile-slide3.png'
import slide4 from '../../images/mobile-slide4.png'
import playstore from '../../images/google-play.png'
import appstore from '../../images/app-store.png'
import downloadicon from '../../images/download-icon.svg'
import signboard from '../../images/sign-board.png'
import bulletingicon from '../../images/bulleting-icon.svg'

import { Swiper, SwiperSlide, } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-fade";
import { Autoplay, EffectFade } from "swiper";
import Navbar from '../01-navbar/Navbar'

const Header = () => {
  return (
    <div className='header'>

        <Navbar />

        <div className='container'>

            <div className='header-content text-center'>

                <div className='header-content-heading'><h1>ENJOY PLAYING MATKA WITH LATA 777</h1></div>

                <div className='header-content-download'>

                  <div className='download'><div className='download-icon'><img src={downloadicon} /></div><h3>Download Now</h3></div>

                </div>

                <div className='header-content-download-btn'>

                  <div className='playstore'><img src={playstore} /></div>
                  <div className='appstore'><img src={appstore} /></div>
                
                </div>

                <div className='sign-board'>

                  <div className='sign-board-img'>
                    
                    <img src={signboard}/>
                    <div className='contact-info'>

                      <div className='whatsapp-icon'><img className='whatsapp-icon-img' src={whatsapp} /></div>
                      <div className='whatsapp-number'><h2>90100-26100</h2></div>
                      <div className='telegram-icon'><img className='telegram-icon-img' src={telegram} /></div>

                    </div>
                    
                  </div>
                 

                </div>

                {/* <div className='header-content-points'>

                  <div className='point point1'><div className='point-icon'><img src={bulletingicon} /></div><h3>APP AVAILABLE FOR IOS & ANDROID</h3></div>
                  <div className='point point2'><div className='point-icon'><img src={bulletingicon} /></div><h3>50K+ HAPPY PLAYERS</h3></div>
                  <div className='point point3'><div className='point-icon'><img src={bulletingicon} /></div><h3>SELECT LANGUAGE OF YOUR CHOICE</h3></div>
                  <div className='point point4'><div className='point-icon'><img src={bulletingicon} /></div><h3>MINIMUM DEPOSITE ₹100</h3></div>

                </div> */}

            </div>

        </div>

        <div className='coin'><img src={coin} /></div>

        <div className='matka'><img src={matka} /></div>

        {/* <div className='whats-number'><h2>90100-26100</h2></div> */}

        {/* <div className='whatsapp'><img className='whatsapp-img' src={whatsapp} /><div className='shadow'></div></div> */}

        {/* <div className='telegram'><img className='telegram-img' src={telegram} /><div className='shadow'></div></div> */}

        <div className='mobile-mockup'>

            <div className='mockup-content'>

                <img className='mockup-img' src={mobilemockup} />

                <div className='slide'>

                    <Swiper
                      spaceBetween={30}
                      effect={"fade"}
                      loop={true}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      modules={[Autoplay, EffectFade]}
                      className="mySwiper"
                    >
                      <SwiperSlide><img src={slide1} /></SwiperSlide>
                      <SwiperSlide><img src={slide2} /></SwiperSlide>
                      <SwiperSlide><img src={slide3} /></SwiperSlide>
                      <SwiperSlide><img src={slide4} /></SwiperSlide>

                    </Swiper>

                </div>

                <div className='mobile-shadow'></div>

            </div>
        
        </div>

    </div>
  )
}

export default Header
